/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AdminDto = {
  /**
   * 관리자 ID
   */
  id: number;
  /**
   * 이메일
   */
  email: string;
  /**
   * 이름
   */
  name?: string;
  /**
   * 관리자 역할
   */
  role: AdminDto.role;
  /**
   * 생성일시
   */
  createdAt: string;
};
export namespace AdminDto {
  /**
   * 관리자 역할
   */
  export enum role {
    SUPER = "SUPER",
    STAFF = "STAFF",
  }
}
